module.exports = __webpack_public_path__ + "img/sld_central_box_green_ta1_ba1.8e78f627.svg";